export default "__VITE_ASSET__C45IKOme__"